<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <modal size="large"
           v-show="show"
           id="ModalConfirmationCommission">

        <template v-slot:header>
            <h3 class="title">Revisão de Comissões</h3>
        </template>

        <template v-slot:body>
            <div class="container">
                <div class="form-row">
                    <div class="col-6">
                        <label for="comPayConfBroker">Corretor</label>
                        <input type="text"
                               id="comPayConfBroker"
                               :value="broker.name"
                               readonly
                               class="form-control-plaintext form-control-sm f-w-700">
                    </div>
                    <div class="col-6">
                        <label for="comPayConfTo">E-mail</label>
                        <input type="text"
                               id="comPayConfTo"
                               :value="broker.email"
                               readonly
                               class="form-control-plaintext form-control-sm f-w-700">
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-12">
                        <label for="comPayConfSubject">Assunto</label>
                        <input type="text"
                               id="comPayConfSubject"
                               maxlength="100"
                               placeholder="Informe o assunto do e-mail"
                               v-model="email_subject"
                               class="form-control form-control-sm">
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-12">
                        <label for="comPayConfText">Texto do E-mail</label>
                        <textarea id="comPayConfText" v-model="email_text" class="form-control form-control-sm"></textarea>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-12 t-r">
                        <br>
                        <div class="btn-group btn-group-sm">
                        <button type="button"
                                @click="$emit('onClose')"
                                :disabled="sending"
                                class="btn btn-sm btn-dark">
                            <svg-icon icon="times"/>
                            Fechar
                        </button>
                        <button type="button"
                                @click="sendEmail"
                                :disabled="sending"
                                class="btn btn-sm btn-theme-1">
                            <svg-icon :icon="sending ? 'sync' : 'envelope'" :svg-class="{'refresh rotate-1-seg': sending}" />
                            {{sending ? 'Enviando...' : 'Enviar'}}
                        </button>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <br>
                        <table v-if="$appUtils.isDesktop()" class="table table-striped table-sm table-bordered">
                            <thead class="thead-dark thead-center">
                            <tr>
                                <th rowspan="2" style="width: 30px">#</th>
                                <th rowspan="2">DATA</th>
                                <th rowspan="2">NR</th>
                                <th rowspan="2">VEND.</th>
                                <th rowspan="2">COMP.</th>
                                <th rowspan="2">FAT. EM</th>
                                <th rowspan="2">QTD NEG/EMB</th>
                                <th colspan="2">AGRISOY</th>
                                <th colspan="2">CORRETOR</th>
                            </tr>
                            <tr>
                                <th>R$</th>
                                <th>%</th>
                                <th>R$</th>
                                <th>%</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(p,idx) in proposals" :key="p.id">
                                <td class="t-c">{{idx + 1}}</td>
                                <td class="t-c">{{p.created_at | formatDate}}</td>
                                <td class="t-c f-w-700">{{p.number}}</td>
                                <td :title="p.seller.name" class="ellipsis">{{p.seller.group.name}}</td>
                                <td :title="p.buyer.name" class="ellipsis">{{p.buyer.group.name}}</td>
                                <td class="t-c" >{{p.billing_date | formatDate}}</td>
                                <td class="t-c" >{{p.quantity | formatNumber(3)}} / {{p.quantity_embedded ? $appUtils.formatNumber(p.quantity_embedded, 3) : 'N/D'}}</td>
                                <td class="t-r f-w-700">{{agrisoyCommission(p, true)}}</td>
                                <td class="t-r f-w-700">{{agrisoyCommission(p, false)}}</td>
                                <td class="t-r f-w-700 c-theme" >{{brokerCommission(p, true)}}</td>
                                <td class="t-r f-w-700 c-theme" >{{brokerCommission(p, false)}}</td>
                            </tr>
                            </tbody>
                            <tfoot>
                            <tr>
                                <td colspan="7" class="t-r f-w-700">TOTAL</td>
                                <td class="t-r f-w-700">{{totals.agrisoy}}</td>
                                <td/>
                                <td class="t-r f-w-700 c-theme">{{totals.broker}}</td>
                                <td/>
                            </tr>
                            </tfoot>
                        </table>
                        <div v-else>
                            <div class="card" v-for="(p,idx) in proposals" :key="p.id">
                                <span class="idx f-w-700">#{{idx + 1}}</span>
                                <span class="dt t-c">DT {{p.created_at | formatDate}}</span>
                                <span class="fat t-c">FAT {{p.billing_date | formatDate}}</span>
                                <span class="nr t-r"><b>{{p.number}}</b></span>

                                <span class="seller ellipsis" :title="p.seller.name">{{p.seller.group.name}}</span>
                                <span class="buyer t-r ellipsis" :title="p.buyer.name">{{p.buyer.group.name}}</span>

                                <span class="neg-tlt">NEGOCIADO | EMBARCADO:</span>
                                <span class="neg-val t-c">{{p.quantity | formatNumber(3)}} | {{p.quantity_embedded ? $appUtils.formatNumber(p.quantity_embedded, 3) : 'N/D'}}</span>

                                <span class="agr f-w-700">AGRISOY</span>
                                <span class="agr-mon t-r f-w-700">R$ {{p.commission | formatMoney}}</span>

                                <span class="broker c-theme f-w-700">CORRETOR</span>
                                <span class="broker-mon t-r c-theme f-w-700">R$ {{brokerCommission(p, true)}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <button type="button"
                    :disabled="sending"
                    @click="$emit('onClose')"
                    class="btn btn-sm btn-dark">
                <svg-icon icon="times"/>
                Fechar
            </button>
        </template>
    </modal>
</template>

<script>
    import {Big} from "big.js";
    import dayjs from "dayjs";
    import {formatMoney} from "@/utils/Utils";

    export default {
        name: "ModalConfirmationCommission",
        props: {
            showModal: {
                type: Boolean,
                default: false
            },
            data: {
                type: Object,
                default: {}
            }
        },
        data() {
            return {
                broker: {},
                proposals: [],
                email_subject: null,
                email_text: null,
                sending: false,
            }
        },
        methods: {
            brokerCommission(proposal, isValue) {

                let com = 0;

                if (isValue) {
                    if(proposal.broker_one.id === this.broker.id) com = proposal.broker_one_commission_value;
                    else com = proposal.broker_two_commission_value;
                } else {
                    if(proposal.broker_one.id === this.broker.id) com = proposal.broker_one_commission;
                    else com = proposal.broker_two_commission;
                }
                return this.$appUtils.formatMoney(com);
            },
            agrisoyCommission(p, isValue) {
              if (isValue) return formatMoney(p.commission)

              if (p.value_or_percent_commission) return 'N/D'

              return p.percentage_commission
            },
            sendEmail() {
                const obj = {
                    message: {
                        subject: this.email_subject,
                        text: this.email_text,
                        broker_id: this.broker.id,
                        ids: this.proposals.map(p => p.id)
                    }
                };

                this.sending = true;
                this.$appHttp.post('/v1/commission_payments/send_review', obj)
                    .then(() => this.$snotify.success('E-mail enviado com sucesso.', this.$appStorage.getUser().name))
                    .catch(console.error)
                    .finally(() => this.sending = false);
            }
        },
        computed: {
            show() {
                if (this.showModal) {
                    this.broker = this.data.broker;
                    this.proposals = this.data.proposals;
                    this.email_text = this.data.email_text;
                    this.email_subject = `Comissão ${this.data.broker.name} - ${dayjs().format('DD/MM/YYYY')}`;
                }
                return this.showModal
            },
            totals() {
                let totAgrisoy = new Big('0');
                let totBroker = new Big('0');

                this.proposals.forEach(p => {
                    totAgrisoy = totAgrisoy.plus(new Big(p.commission));

                    let value = 0;
                    if(p.broker_one.id === this.broker.id) value = p.broker_one_commission_value;
                    else value = p.broker_two_commission_value;

                    totBroker = totBroker.plus(new Big(value));
                });

                return {
                    agrisoy: this.$appUtils.formatMoney(parseFloat(totAgrisoy.toString())),
                    broker: this.$appUtils.formatMoney(parseFloat(totBroker.toString())),
                }
            }

        },
    }
</script>
<style scoped lang="scss">
    .card {
        display: grid;
        width: 100%;
        grid-template-columns: repeat(4, 1fr);
        grid-template-rows: auto;
        grid-template-areas: "idx dt fat nr" "seller seller buyer buyer" "neg-tlt neg-tlt neg-val neg-val" "agr agr agr agr-mon"
        "broker broker broker broker-mon";
        grid-gap: 5px;
        font-size: .8em;
        padding: 5px;

        &:not(:first-child) {
            border-top: 1px solid #e7eaec;
        }

        > .idx {grid-area: idx}
        > .dt {grid-area: dt}
        > .fat {grid-area: fat}
        > .nr {grid-area: nr}

        > .seller {grid-area: seller}
        > .buyer {grid-area: buyer}
        > .neg-tlt {grid-area: neg-tlt}
        > .neg-val {grid-area: neg-val}

        > .agr {grid-area: agr}
        > .agr-mon {grid-area: agr-mon}

        > .broker {grid-area: broker}
        > .broker-mon {grid-area: broker-mon}
    }
</style>
